export default "__VITE_ASSET__9b28950a__"